import { AlarmListingFieldName } from '../services/alarms.types';

export const ALARMS_SORT_FIELD: Record<string, AlarmListingFieldName> = {
  dateTime: AlarmListingFieldName.DateTimeUtcUpdated,
  commDeviceId: AlarmListingFieldName.CommDeviceId,
  serialNumber: AlarmListingFieldName.SerialNumber
};
